import {
	animation,
	trigger,
	animate,
	transition,
	state,
	style,
	query,
	group,
	animateChild,
	stagger
} from '@angular/animations';

export const footerAnimation = trigger('footerAnimation', [
	transition('show => hide', [
    style({ transform: 'translateY(0%)' }),
    animate('0.8s ease-in', style({ transform: 'translateY(100%)' })),
  ]),
  transition('hide => show', [
    animate('0ms linear', style({ transform: 'translateY(0%)' }))
  ])
]);
